<template>
    <main
        name="default"
        class="template template__main"
    >
        <slot name="default" />
    </main>
</template>

<style lang="less" src="./TemplateDefault.less" />
